import { GET, POSTJSON } from './http'
import qs from 'qs'

// 获取微信授权地址
export const getAuthorizeUrl = (params) =>
  GET('/api/weixin/panel/getAuthorizeUrl/' + params)

// 登录授权
export const getLoginAuth = (params) =>
  GET('/api/weixin/panel/loginAuth/' + params)


// 获取公众号id
export const getAppId = (params) => GET('/api/wechat/getAppId', params)

// 生成签名
export const getJsAPISignature = (params) =>
  GET('/api/wechat/getJsAPISignature', params)

// 获取个人信息
export const getPanel = () => GET('/api/weixin/panel/getPanel')

// 回去聊天答案
export const robotChat = (params) =>
  GET('/api/weixin/robot/chat',params)
